import styled from 'styled-components';

export const TextButtonAction = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.4rem;
  font-size: 14px;
`;
const ButtonBase = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.4rem 0.6rem;

  width: 80px;
  border-radius: 6px;

  &:disabled {
    cursor: default;
    filter: grayscale(100%);
  }
`;
export const ButtonActionConfirm = styled(ButtonBase)`
  background: ${({ theme }) => theme.pantone2726C};
  border: none;
  color: ${({ theme }) => theme.pantone656C};
`;

export const ButtonActionCancel = styled(ButtonBase)`
  background: ${({ theme }) => theme.pantone656C};
  border: 1px solid ${({ theme }) => theme.pantone2726C};
  color: ${({ theme }) => theme.pantone2726C};
`;

export const ModalSide = styled.div`
  position: relative;
  .show {
    right: 0;
    overflow: auto;
    padding-bottom: 100px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    .show {
      padding-bottom: 70px;
    }
  }
`;

interface IModalSideContent {
  padding?: string;
  width?: string;
  $zIndex?: number;
}

export const ModalSideContent = styled.div<IModalSideContent>`
  position: fixed;
  top: 58px;
  right: ${({ width }) => (width ? `calc(-1 * ${width})` : '-450px')};
  width: ${({ width }) => width || '450px'};
  max-width: calc(100vw - 16px);
  height: 100%;
  background-color: #fff;
  padding: ${({ padding }) => padding || '20px'};
  box-sizing: border-box;
  z-index: ${({ $zIndex }) => $zIndex ?? 100};
  text-align: left;
  transition: 0.5s all ease;

  @media (max-width: 550px) {
    width: 90%;
    right: -100%;
  }
`;

interface IModalSideOverlay {
  $zIndex?: number;
}
export const ModalSideOverlay = styled.div<IModalSideOverlay>`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: ${({ $zIndex }) => $zIndex ?? 50};
`;

interface ITitleModalProps {
  hasBackgroundTitle?: boolean;
}
export const TitleModal = styled.h6<ITitleModalProps>`
  font-weight: bold;
  font-size: 1.425rem;
  margin-bottom: 0;
  padding: 1rem;
  color: ${({ theme, hasBackgroundTitle }) =>
    hasBackgroundTitle ? theme.white : 'initial'};
  background-color: ${({ hasBackgroundTitle, theme }) =>
    hasBackgroundTitle ? theme.pantoneBlack : 'transparent'};
`;
